import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import AboutPage from '../pages/about/page';
import AdminPage from '../pages/admin/page';
import ContactPage from '../pages/contact/page';
import GalleryPage from '../pages/gallery/page';
import HomePage from '../pages/home/page';
import ReviewsPage from '../pages/reviews/page';
import ServicesPage from '../pages/services/page';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '/gallery', element: <GalleryPage /> },
  { path: '/reviews', element: <ReviewsPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
